import { validarRangoFechas } from '../dateValidation.js'
import { calcPrecioPedido } from './matchHelpers.js'

export const MAPA_PEDIDOS = {
  comprador: {
    titulo: 'Comprador',
    opciones: ({ pedidos }) => [
      ...new Map(
        pedidos.map((p) => [
          p.idComprador,
          { label: p.pedidoItems[0].compradorNombre, valor: p.idComprador }
        ])
      ).values()
    ],
    filterFn: (p, v) => p.idComprador === Number(v)
  },

  vendedor: {
    titulo: 'Vendedor',
    opciones: ({ pedidos }) => [
      ...new Map(
        pedidos.map((p) => [
          p.idVendedor,
          { label: p.pedidoItems[0].vendedorNombre, valor: p.idVendedor }
        ])
      ).values()
    ],
    filterFn: (p, v) => p.idVendedor === Number(v)
  },

  idPedidoItemEstado: {
    titulo: 'Estado del envío',
    opciones: ({ pedidos }) => [
      ...new Map(
        pedidos.flatMap(({ pedidoItems }) =>
          pedidoItems.map((item) => [
            item.idPedidoItemEstado,
            { valor: item.idPedidoItemEstado, label: item.estadoNombre }
          ])
        )
      ).values()
    ],
    filterFn: (p, v) => p.pedidoItems.some((item) => item.idPedidoItemEstado === v)
  },

  idPagoEstado: {
    titulo: 'Estado del pago',
    opciones: ({ pedidos }) => [
      ...new Map(
        pedidos.flatMap(({ pedidoItems }) =>
          pedidoItems.map((item) => [
            item.idPagoEstado,
            { valor: item.idPagoEstado, label: item.estadoPago }
          ])
        )
      ).values()
    ],
    filterFn: (p, v) => p.pedidoItems.some((item) => item.idPagoEstado === v)
  },

  precioDesde: { tipo: 'precio', filterFn: (p, v) => calcPrecioPedido(p) >= Number(v) },
  precioHasta: { tipo: 'precio', filterFn: (p, v) => calcPrecioPedido(p) <= Number(v) },

  fechaDesde: {
    tipo: 'fecha',
    label: 'compra desde',
    filterFn: (p, v) => validarRangoFechas(v, p?.ventaItems?.[0]?.fechaPedido ?? p.fechaPedido)
  },
  fechaHasta: {
    tipo: 'fecha',
    label: 'compra hasta',
    filterFn: (p, v) => validarRangoFechas(p?.ventaItems?.[0]?.fechaPedido ?? p.fechaPedido, v)
  },

  esVentas: { filterFn: () => true },

  textoBusqueda: {
    placeholder: 'Buscar por título o NRO pedido...',
    filterFn: (p, v, filtros) => {
      const val = v.trim().toLowerCase()
      if (!val) return true
      const items = Array.isArray(p.pedidoItems) ? p.pedidoItems : []
      return (
        items.some((item) => (item?.titulo || '').toLowerCase().includes(val)) ||
        (filtros.esVentas
          ? items.some((item) => (item?.compradorNombre || '').toLowerCase().includes(val))
          : items.some((item) => (item?.vendedorNombre || '').toLowerCase().includes(val))) ||
        p.idPedido.toString().includes(val)
      )
    }
  }
}
